import React, { FC } from 'react'
import { TilesInner } from '../style'
import { Tile } from './tile'

//* utils
import formatInlineCode, {
  addClassToFirstElementOfReadOnlyJSX,
  addClassToLastElementOfReadOnlyJSX,
} from '../../../../utils/shortTextFormatting'

type Props = {
  tilesData: any
}

export const InnerTiles: FC<Props> = ({ tilesData }) => {
  const gridColumnsClass =
    tilesData.numberOfColumns == 3 ? 'Tiles__Item--ThreeCol' : 'Tiles__Item--FourCol'

  return (
    <TilesInner
      className={gridColumnsClass}
      $useCase={tilesData.useCase}
      $twoTiles={tilesData.tiles.length === 2}>
      {tilesData.tiles?.map((tile: any, i: number) => {
        if (!tile) return null
        const tileData = {
          title: tile.title || '',
          cta: tile.tileCta || null,
          cta2: tile.tileCta2 || null,
          orangeTheme: tile.theme || '',
          text: tile.text || '',
          rtfText: tile.rtfText || '',
          finePrint: tile.finePrint || '',
          tileUseCase: tile.useCase || '',
          image: {
            url: tile.tileMedia?.image?.file?.url,
            altText: tile.tileMedia?.altText,
          },
        }

        let formattedTitle
        if (tileData.title) {
          formattedTitle = formatInlineCode(tileData.title)

          //* pricing tiles fineprint inline formatter
          if (Array.isArray(formattedTitle)) {
            addClassToFirstElementOfReadOnlyJSX(formattedTitle, 'block-formatter')
            addClassToLastElementOfReadOnlyJSX(formattedTitle, 'inline-formatter')
          }
        }

        return (
          <Tile
            key={`TileItem--${i}`}
            tileData={tileData}
            useCase={tilesData.useCase}
            formattedTitle={formattedTitle}
          />
        )
      })}
    </TilesInner>
  )
}
